// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__SJck7","headerTitle":"style_headerTitle__3KyaS","closeButton":"style_closeButton__3BMLr","spinning":"style_spinning__2DbSj"};